import { Form } from 'antd';
import type { FormItemProps } from 'antd';

type Props = FormItemProps & {
  inline?: boolean;
};

export function SlaFormField({ className, inline = false, ...props }: Props) {
  const classes = [
    inline ? 'sla-form-item-inline' : 'sla-form-item-stable',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <Form.Item className={classes} {...props} />;
}
